import moment from 'moment-timezone';

export const test = {
  currentPage: 1,
  itemsPerPage: 10,
  period: {
    from: moment().tz('America/Los_Angeles')
      .startOf('day')
      .format('MM/DD/YYYY'),
    to: moment().tz('America/Los_Angeles')
      .startOf('day')
      .add(1, 'day')
      .format('MM/DD/YYYY'),
  },
  items: [],
  total: {
    numberOfRequests: 0,
    fillRate: 0,
  },
  sort: {
    key: 'fillRate',
    order: -1,
  },
  filter: {
    country: '',
    appId: '',
    placementId: '',
    adUnitType: '',
    forNative: false,
  },
};

export const initial = {
  currentPage: 1,
  itemsPerPage: 10,
  period: {
    from: moment().tz('America/Los_Angeles')
      .startOf('day')
      .format('MM/DD/YYYY'),
    to: moment().tz('America/Los_Angeles')
      .startOf('day')
      .add(1, 'day')
      .format('MM/DD/YYYY'),
  },
  items: [],
  total: {
    numberOfRequests: 0,
    fillRate: 0,
  },
  sort: {
    key: 'fillRate',
    order: -1,
  },
  filter: {
    country: '',
    appId: '',
    placementId: '',
    adUnitType: '',
    forNative: false,
  },
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/fillRate.state.js
 **/